(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PurchaseStatus', PurchaseStatus);

    PurchaseStatus.$inject = ['$resource'];

    function PurchaseStatus ($resource) {
        var resourceUrl =  'api/purchase-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
